module.exports = __webpack_public_path__ + "static/carousel-image-4-c333e5389958580b16d7be8822af9d4a.jpg";